import { SpaceMemberRole } from './space';
export var ProjectMemberRole;
(function (ProjectMemberRole) {
    ProjectMemberRole["VIEWER"] = "viewer";
    ProjectMemberRole["INTERACTIVE_VIEWER"] = "interactive_viewer";
    ProjectMemberRole["EDITOR"] = "editor";
    ProjectMemberRole["DEVELOPER"] = "developer";
    ProjectMemberRole["ADMIN"] = "admin";
})(ProjectMemberRole || (ProjectMemberRole = {}));
export const ProjectMemberRoleLabels = {
    [ProjectMemberRole.VIEWER]: 'Viewer',
    [ProjectMemberRole.INTERACTIVE_VIEWER]: 'Interactive Viewer',
    [ProjectMemberRole.EDITOR]: 'Editor',
    [ProjectMemberRole.DEVELOPER]: 'Developer',
    [ProjectMemberRole.ADMIN]: 'Admin',
};
const RoleTypes = ['organization', 'project', 'group', 'space_group'];
export const ProjectRoleOrder = {
    [ProjectMemberRole.VIEWER]: 0,
    [ProjectMemberRole.INTERACTIVE_VIEWER]: 1,
    [ProjectMemberRole.EDITOR]: 2,
    [ProjectMemberRole.DEVELOPER]: 3,
    [ProjectMemberRole.ADMIN]: 4,
};
export const SpaceRoleOrder = {
    [SpaceMemberRole.VIEWER]: 0,
    [SpaceMemberRole.EDITOR]: 1,
    [SpaceMemberRole.ADMIN]: 2,
};
//# sourceMappingURL=projectMemberRole.js.map